import { graphql, apiAxiosCMS } from 'services/api';
import { GET_PAGES } from 'graphqlQueriesAndMutations/queries';
import { DynamicShowCaseProps } from 'types/DynamicShowCaseProps';
import { ElementDynamicOptionsProps } from 'types/ElementDynamicOptionProps';

export async function getDynamicShowCase(
	setListMenuItensLocation: React.Dispatch<
		React.SetStateAction<DynamicShowCaseProps[]>
	>,
	setActualPage: React.Dispatch<React.SetStateAction<number>>,
	setTotalPages: React.Dispatch<React.SetStateAction<number>>,
	actualPage: number,
	handleNotify: any
) {
	try {
		const { data } = await graphql.query({
			query: GET_PAGES,
			variables: { limit: 20, page: actualPage },
			fetchPolicy: 'no-cache'
		});

		setListMenuItensLocation(data?.pagesPaginated?.data || []);
		setActualPage(data?.pagesPaginated?.page || 1);
		setTotalPages(data?.pagesPaginated?.totalPages || 1);
	} catch (error: any) {
		handleNotify(
			error?.message || 'Erro ao buscar as vitrines dinâmicas',
			'error'
		);
	}
}

interface RespGetComponents {
	isSuccess: boolean;
	data: ElementDynamicOptionsProps[];
}

export async function getOptionList(handleNotify: any) {
	const resp: RespGetComponents = { isSuccess: false, data: [] };
	await apiAxiosCMS
		.get('schemas?languageSlug=en')
		.then((res) => {
			const newList: ElementDynamicOptionsProps[] = [];

			if (res.data && res.data.length > 0) {
				res.data.forEach((component: ElementDynamicOptionsProps) => {
					if (component.active) {
						newList.push(component);
					}
				});
			}
			resp.data = newList;
			resp.isSuccess = true;
		})
		.catch((error) => {
			resp.data = [];
			resp.isSuccess = false;
			handleNotify(error?.message || 'Erro ao buscar os componentes', 'error');
		});

	return resp;
}
